/**
 * @generated SignedSource<<6de3df51285161fd6dc925bc78608486>>
 * @relayHash d0b91783b4821bd978a5d2fd0c120efd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 601f697afe038b9fda9c5a6d14bb839534ca3e6825e77daf39701b3165183f73

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceUpdateMarkdownModeInput = {
  contentId: string;
  isMarkdownMode: boolean;
  title?: string | null | undefined;
};
export type UpdateMarkdownModeMutation$variables = {
  cloudId: string;
  input: ConfluenceUpdateMarkdownModeInput;
};
export type UpdateMarkdownModeMutation$data = {
  readonly confluence_updateMarkdownMode: {
    readonly contentId: string;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly isMarkdownMode: boolean | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type UpdateMarkdownModeMutation = {
  response: UpdateMarkdownModeMutation$data;
  variables: UpdateMarkdownModeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateMarkdownModePayload",
    "kind": "LinkedField",
    "name": "confluence_updateMarkdownMode",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "isMarkdownMode"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "UpdateMarkdownModeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateMarkdownModeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d0b91783b4821bd978a5d2fd0c120efd",
    "id": "601f697afe038b9fda9c5a6d14bb839534ca3e6825e77daf39701b3165183f73",
    "metadata": {},
    "name": "UpdateMarkdownModeMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateMarkdownModeMutation($cloudId:ID!,$input:ConfluenceUpdateMarkdownModeInput!){confluence_updateMarkdownMode(cloudId:$cloudId,input:$input){contentId,isMarkdownMode,success,errors{message}}}"
  }
};
})();

(node as any).hash = "47efe092e8db2f8efa6d6b357d26f1f8";

export default node;
